<div class="l-contents-wrap">
  <div class="l-main">
    <!-- [ヘッダー下メニュー] -->
    <div class="l-top-navi">
      <div class="l-wrap l-wrap--sp-tb-full">
        <div class="l-wrap__inner">
          <div class="l-top-navi__inner l-top-navi__inner--has-progress">
            <div class="l-top-navi__back-area">
              <button id="back-button" class="l-top-navi__back-link" (click)="onClickBack($event)">
                <span class="u-visually-hidden" [innerHTML]="'reader.goBackToPreviousPage' | staticMsg"></span>
              </button>
            </div>
            <div class="l-top-navi__heading-area">
              <h1 class="l-top-navi__heading-text">{{ 'm_static_message-heading.flightSearchResult' | staticMsg }}</h1>
            </div>
            <!-- [ヘッダー下メニュー ボタンエリア] -->
            <ng-container *ngIf="!isPC">
              <div class="l-top-navi__function-area">
                <div class="l-top-navi__function-item">
                  <button
                    id="reSearch-button1"
                    class="l-top-navi__function-btn l-top-navi__function-btn--modify"
                    (throttleClick$)="openReSearchModal()"
                    aswThrottleClick
                  >
                    <span class="l-top-navi__function-btn-text">{{
                      'm_static_message-label.searchChange' | staticMsg
                    }}</span>
                  </button>
                </div>
              </div>
            </ng-container>
            <!-- //[ヘッダー下メニュー ボタンエリア] -->

            <!-- [ステップナビゲーション] -->
            <div class="l-top-navi__progress-area">
              <ol class="l-top-navi__progress-list" [attr.aria-label]="'reader.breadcrumb.navigation' | staticMsg">
                <li
                  class="l-top-navi__progress-item l-top-navi__progress-item--active l-top-navi__progress-item--current"
                >
                  <em class="l-top-navi__progress-wrap">
                    <span
                      *ngIf="isPC"
                      class="u-visually-hidden"
                      [innerHTML]="'reader.breadcrumb.current' | staticMsg"
                    ></span>
                    <span
                      *ngIf="isSP || isTB"
                      class="u-visually-hidden"
                      [innerHTML]="'alt.stepBar' | staticMsg : { '0': this.stepNum, '1': this.currentStepNum }"
                    ></span>
                    <span class="l-top-navi__progress-num">{{
                      'm_static_message-label.breadcrumb.first' | staticMsg
                    }}</span>
                    <span class="l-top-navi__progress-text">{{
                      'm_static_message-label.flightSearch' | staticMsg
                    }}</span>
                  </em>
                </li>
                <li class="l-top-navi__progress-item">
                  <div class="l-top-navi__progress-wrap">
                    <span class="l-top-navi__progress-num">{{
                      'm_static_message-label.breadcrumb.second' | staticMsg
                    }}</span>
                    <span class="l-top-navi__progress-text">{{
                      'm_static_message-label.passengerInformationInput' | staticMsg
                    }}</span>
                  </div>
                </li>
                <li class="l-top-navi__progress-item">
                  <div class="l-top-navi__progress-wrap">
                    <span class="l-top-navi__progress-num">{{
                      'm_static_message-label.breadcrumb.third' | staticMsg
                    }}</span>
                    <span class="l-top-navi__progress-text">{{
                      'm_static_message-label.suchAsSeatAssign' | staticMsg
                    }}</span>
                  </div>
                </li>
                <li class="l-top-navi__progress-item">
                  <div class="l-top-navi__progress-wrap">
                    <span class="l-top-navi__progress-num">{{
                      'm_static_message-label.breadcrumb.fourth' | staticMsg
                    }}</span>
                    <span class="l-top-navi__progress-text">{{ 'm_static_message-label.purchase2' | staticMsg }}</span>
                  </div>
                </li>
                <li class="l-top-navi__progress-item">
                  <div class="l-top-navi__progress-wrap">
                    <span class="l-top-navi__progress-num">{{
                      'm_static_message-label.breadcrumb.fifth' | staticMsg
                    }}</span>
                    <span class="l-top-navi__progress-text">{{ 'm_static_message-label.complete' | staticMsg }}</span>
                  </div>
                </li>
              </ol>
            </div>
            <!-- [ヘッダー下メニュー ボタンエリア] -->
            <ng-container *ngIf="isPC">
              <div class="l-top-navi__function-area">
                <div class="l-top-navi__function-item">
                  <button
                    id="reSearch-button2"
                    class="l-top-navi__function-btn l-top-navi__function-btn--modify"
                    (throttleClick$)="openReSearchModal()"
                    aswThrottleClick
                  >
                    <span class="l-top-navi__function-btn-text">{{
                      'm_static_message-label.searchChange' | staticMsg
                    }}</span>
                  </button>
                </div>
              </div>
            </ng-container>
            <!-- //[ヘッダー下メニュー ボタンエリア] -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
